<template>
  <h6>Sociotherapie</h6>
  <div class="table-responsive overflow-auto">
    <table id="dataTable1" class="table table-striped">
      <thead>
      <tr>
        <th>Status</th>
        <th>Maßnahmenart</th>
        <th>Standort</th>
        <th>Versicherungsnr</th>
        <th>Start</th>
        <th>Ende</th>
        <th>Stand</th>
        <th>Stand %</th>
        <th>UN fehlt</th>
        <th>Noch abzurechnende Stunden</th>
        <th>Coach</th>
        <th>Letzter Termin</th>
        <th></th>
      </tr>

      </thead>
      <tbody>
      <tr v-for="coaching in socioTherapyCoachingList" :key="coaching.id">
        <td>{{ coaching?.statusTranslation }}</td>
        <td>{{ coaching?.operationTypeTranslation }}</td>
        <td>{{ coaching?.unemployed?.location?.name }}</td>
        <td>{{ coaching?.unemployed?.insuranceNumber }}</td>
        <td>{{ coaching?.startDate }}</td>
        <td>{{ coaching?.endDate }}</td>
        <td>{{ coaching?.unitsHeld }}</td>
        <td>{{ coaching?.unitsHeldPercent }} %</td>
        <td style="text-align: center">{{ coaching?.notSignedUnits }}</td>
        <td style="text-align: center">?????</td>
        <td>{{ coaching?.coach?.firstName }} {{ coaching?.coach?.lastName }}</td>
        <td>{{ coaching?.lastUnit }}</td>
        <td>
          <router-link
              :to="{
                  name: 'analyticsUnemployedDetailsOverviewCoachingDetails',
                  params: {
                    coachingType: 'socio-therapy-coaching',
                    id: coaching.id
                  }
                }"
              class="btn btn-primary">
            Analytik
          </router-link>
        </td>
      </tr>

      </tbody>
    </table>
  </div>
</template>

<script setup>
import { defineProps } from 'vue';

const props = defineProps({
  socioTherapyCoachingList: {
    require: true,
  },
});
</script>

<style scoped>

</style>